import Fab from "@material-ui/core/Fab";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AddIcon from "@material-ui/icons/Add";
import FormQuizCategory from "components/FormQuizCategory";
import Page from "components/Page";
// components
import QuizCategoriesList from "components/QuizCategoriesList";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class WrapperQuizCategoriesPage extends Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    loading: PropTypes.bool,

    //quizCategories
    quizCategories: PropTypes.array,
    getQuizCategoryById: PropTypes.func,
    createQuizCategory: PropTypes.func,
    deleteQuizCategory: PropTypes.func,
    updateQuizCategory: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedQuizCategory: undefined,
      formQuizCategoryOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { quizCategories } = this.props;

    switch (index) {
      case 0:
        return (
          <QuizCategoriesList
            quizCategories={quizCategories}
            onSelect={(selectedQuizCategory) =>
              this.setState({
                selectedQuizCategory,
                formQuizCategoryOpen: true,
              })
            }
          />
        );
      default:
    }
  }

  render() {
    const {
      classes,
      history,
      loading,
      createQuizCategory,
      deleteQuizCategory,
      updateQuizCategory,
      refresh,
    } = this.props;

    const { index, selectedQuizCategory, formQuizCategoryOpen } = this.state;

    return (
      <Page
        helmet={"QuizCategories"}
        loadingMessage={"Loading Document"}
        loading={loading}
        fab={
          <Fab
            variant="fab"
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={() => this.setState({ formQuizCategoryOpen: true })}
          >
            <AddIcon />
          </Fab>
        }
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push(`?index=${v}`);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="QuizCategories"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormQuizCategory
          open={formQuizCategoryOpen}
          quizCategory={selectedQuizCategory}
          close={() => {
            this.setState({
              formQuizCategoryOpen: false,
            });
            setTimeout(
              () =>
                this.setState({
                  selectedQuizCategory: undefined,
                }),
              200
            );
          }}
          createQuizCategory={createQuizCategory}
          deleteQuizCategory={deleteQuizCategory}
          updateQuizCategory={updateQuizCategory}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperQuizCategoriesPage);
